/**
 * @generated SignedSource<<417bf0e3a378cd75b896f86e60221f6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutProgressReview_transaction$data = {
  readonly isNegotiable: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutDeliveryReview_transaction">;
  readonly " $fragmentType": "CheckoutProgressReview_transaction";
};
export type CheckoutProgressReview_transaction$key = {
  readonly " $data"?: CheckoutProgressReview_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutProgressReview_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutProgressReview_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutDeliveryReview_transaction"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isNegotiable",
      "storageKey": null
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "2b16bc8f4ebda5ca25823069d14aa563";

export default node;
